// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";

// import HomeRoutes from "./HomeRoutes";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     [theme.breakpoints.down("md")]: {
//       backgroundColor: "white",
//     },
//   },
// }));

// const Routes = () => {
//   const classes = useStyles();

//   return (
//     <div className={classes.root}>
//       <HomeRoutes />
//     </div>
//   );
// };
// export default Routes;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import { BrowserRouter, Redirect, Route, useLocation } from "react-router-dom";

// import GetPageData from "../hooks/GetPageData";

// // import GramRoutes from "./GramRoutes";
// import CheckIfGram from "./CheckIfGramAvailable";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     [theme.breakpoints.down("md")]: {
//       // backgroundColor: "white",
//     },
//   },
// }));

// const Routes = () => {
//   const classes = useStyles();
//   // const { ready, data, error } = GetPageData("navbar");
//   const location = useLocation();

//   // function getSubdomain(hostname) {
//   //   let url = hostname;
//   //   var regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);

//   //   return url.match(regex);
//   // }

//   // console.log(
//   //   "get location",
//   //   window.location.host,
//   //   getSubdomain(window.location.host)
//   // );

//   return <CheckIfGram gram={"hasnapur"} />;
// };
// export default Routes;

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { BrowserRouter, Redirect, Route, useLocation } from "react-router-dom";

import HomeRoutes from "./HomeRoutes";
import GramRoutes from "./GramRoutes";
import CheckIfGram from "./CheckIfGramAvailable";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
}));

const Routes = () => {
  const classes = useStyles();
  // const { ready, data, error } = GetPageData("navbar");
  const location = useLocation();

  function subDomain(url) {
    // IF THERE, REMOVE WHITE SPACE FROM BOTH ENDS
    url = url.replace(new RegExp(/^\s+/), ""); // START
    url = url.replace(new RegExp(/\s+$/), ""); // END

    // IF FOUND, CONVERT BACK SLASHES TO FORWARD SLASHES
    url = url.replace(new RegExp(/\\/g), "/");

    // IF THERE, REMOVES 'http://', 'https://' or 'ftp://' FROM THE START
    url = url.replace(new RegExp(/^http\:\/\/|^https\:\/\/|^ftp\:\/\//i), "");

    // IF THERE, REMOVES 'www.' FROM THE START OF THE STRING
    url = url.replace(new RegExp(/^www\./i), "");

    // REMOVE COMPLETE STRING FROM FIRST FORWARD SLASH ON
    url = url.replace(new RegExp(/\/(.*)/), "");

    // REMOVES '.??.??' OR '.???.??' FROM END - e.g. '.CO.UK', '.COM.AU'
    if (url.match(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i))) {
      url = url.replace(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i), "");

      // REMOVES '.??' or '.???' or '.????' FROM END - e.g. '.US', '.COM', '.INFO'
    } else if (url.match(new RegExp(/\.[a-z]{2,4}$/i))) {
      url = url.replace(new RegExp(/\.[a-z]{2,4}$/i), "");
    }

    // CHECK TO SEE IF THERE IS A DOT '.' LEFT IN THE STRING
    var subDomain = url.match(new RegExp(/\./g)) ? true : false;

    return subDomain;
  }
  function getSubdomain(hostname) {
    let url = hostname.replace(/^www\./, "");

    // var regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
    console.log("url domain", url);
    let sub = url.split(".")[1] ? url.split(".")[0] : false;
    console.log("sub domain", sub, subDomain(window.location.host));
    return subDomain(window.location.host) ? sub : false;
    // return url.match(regex);
  }
  // console.log("getsubdomain", getSubdomain(window.location.host));

  // console.log(
  //   "get location",
  //   window.location.host,
  //   getSubdomain(window.location.host)
  // );
  React.useEffect(() => {
    ReactGA.initialize("UA-188253229-1");
  }, []);
  return (
    <>
      <Helmet>
        <title>Egram Panchayat</title>
        <meta name="description" content="Welcome to e-gram panchayat" />

        <meta property="og:title" content="Egram panchayat" />
        <meta property="og:url" content="https://egrampanchayat.in" />
        <meta property="og:description" content="Egram panchayat website" />
        <meta
          property="og:image"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta
          property="og:image:secure_url"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_IN" />
      </Helmet>
      {!getSubdomain(window.location.hostname) ? (
        <HomeRoutes />
      ) : (
        <CheckIfGram gram={getSubdomain(window.location.hostname)} />
      )}

      {/* <CheckIfGram gram={"lohej"} /> */}
    </>
  );
};
export default Routes;
